export default function Ambulanceserviceview() {
    console.log("jkdfajkdfhajfhajdfhsdajfhsjdafh")
  return (
    <div>
      ambulance service
    </div>
  )
}
